import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "../../../../utils/lazyImportRouteComponent"

export const Route = createFileRoute("/app/my/absences/$id")({
  component: lazyImportRouteComponent(
    () => import("./-components/AbsenceRequestDetailPage"),
    "AbsenceRequestDetailPage"
  ),
  beforeLoad: ({ context: { ts } }) => ({
    getTitle: () => ts.absences.t("MyLeaveRequest"),
  }),
})
